import { cloneDeep } from 'lodash';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { PossibleRole } from '../../../../../objects/user/roles/types';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsRequest } from '../../generic/communications-request/communications-request';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

import { CommunicationsRequestConferenceParticipantCreateConstructor } from './communications-request-conference-participant-create-constructor';
import { CommunicationsRequestConferenceParticipantCreateSchema } from './communications-request-conference-participant-create-schema';

export class CommunicationsRequestConferenceParticipantCreate extends CommunicationsRequest {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected conferenceFriendlyName!: string;

  protected to!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsRequestConferenceParticipantCreateConstructor) {
    super({ ...parameters, [CommunicationsRequestSchema.type]: CommunicationsRequestName.conferenceParticipantCreate });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsRequestConferenceParticipantCreate {
    return new CommunicationsRequestConferenceParticipantCreate(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsRequestConferenceParticipantCreate.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsRequestConferenceParticipantCreateSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Roles
  /////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line class-methods-use-this
  public getRequiredRoles(): PossibleRole[] {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  public getRequiredAdminRoles() {
    return [];
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConferenceFriendlyName() {
    return cloneDeep(this.conferenceFriendlyName);
  }

  public getTo() {
    return cloneDeep(this.to);
  }
}
